import { render, staticRenderFns } from "./SupervisorsReport.vue?vue&type=template&id=6bad5395&scoped=true"
import script from "./SupervisorsReport.vue?vue&type=script&lang=js"
export * from "./SupervisorsReport.vue?vue&type=script&lang=js"
import style0 from "./SupervisorsReport.vue?vue&type=style&index=0&id=6bad5395&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad5395",
  null
  
)

export default component.exports